import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { AuthGuard, ConfigModule, I18nModule, provideConfig } from '@spartacus/core'
import { translationOverwrites } from '../../../../../public/asaleocare.translate'
import { ImageLibraryComponent } from './image-library.component'

@NgModule({
  declarations: [ImageLibraryComponent],
  imports: [
    CommonModule,
    I18nModule,
    ConfigModule.withConfig({
      i18n: { resources: translationOverwrites }
    })
  ],
  providers: [
    provideConfig({
      cmsComponents: {
        imageLibraryComponent: {
          component: ImageLibraryComponent,
          guards: [AuthGuard]
        }
      }
    })
  ]
})
export class ImageLibraryModule {}
